import React from "react";
import NavigationItem from "../NavigationItem";

export default function NavigationList({ items }) {
  return (
    <ul className="app-list app-header-list">
      {items.map((item, itemIndex) => (
        <NavigationItem key={itemIndex} item={item} />
      ))}
    </ul>
  );
}
